export var CardCssClass;
(function (CardCssClass) {
    CardCssClass["Base"] = "iress-card";
    CardCssClass["Card"] = "iress-card__card";
    CardCssClass["Wrapper"] = "iress-card__wrapper";
    CardCssClass["Prepend"] = "iress-card__prepend";
    CardCssClass["TopRight"] = "iress-card__top-right";
    CardCssClass["TopRightButton"] = "iress-card__top-right--button";
    CardCssClass["Supplemental"] = "iress-card__supplemental";
    CardCssClass["Footer"] = "iress-card__footer";
    CardCssClass["Header"] = "iress-card__header";
    CardCssClass["HeaderWrapper"] = "iress-card__header-wrapper";
    CardCssClass["Content"] = "iress-card__content";
    CardCssClass["Body"] = "iress-card__body";
    CardCssClass["Heading"] = "iress-card__heading";
    CardCssClass["Link"] = "iress-card__link";
    CardCssClass["Button"] = "iress-card__button";
    CardCssClass["SupplementalFirst"] = "iress-card--supplemental-first";
    CardCssClass["Stretch"] = "iress-card--stretch";
    CardCssClass["Clickable"] = "iress-card--clickable";
    CardCssClass["HasHeading"] = "iress-card--has-heading";
    CardCssClass["HasPrepend"] = "iress-card--has-prepend";
    CardCssClass["HasSupplemental"] = "iress-card--has-supplemental";
    CardCssClass["HasSlots"] = "iress-card--has-slots";
    CardCssClass["Selected"] = "iress-card--selected";
})(CardCssClass || (CardCssClass = {}));
export var CardSlot;
(function (CardSlot) {
    CardSlot["Footer"] = "footer";
    CardSlot["Header"] = "header";
    CardSlot["Prepend"] = "prepend";
    CardSlot["TopRight"] = "top-right";
    CardSlot["Supplemental"] = "supplemental";
})(CardSlot || (CardSlot = {}));
//# sourceMappingURL=card.types.js.map